<template>
  <ul v-if="!!container?.schoolLevels?.length" class="flex items-start">
    <li
      v-for="(schoolLevel, index) in container?.schoolLevels"
      :key="schoolLevel.slug"
      class="inline-block relative"
    >
      <router-link
        :to="routes[schoolLevel.slug]"
        custom
        v-slot="{ href, route, navigate, isActive, isExactActive }"
      >
        <a
          :href="href"
          :class="[
            text - white,
            getButtonClass(schoolLevel.title, isActive),
            index === 0 ? 'button--rounded-left' : '',
            index === container.schoolLevels.length - 1
              ? 'button--rounded-right'
              : '',
          ]"
          class="button block py-[12px] z-10"
          @click="navigate"
          >{{ schoolLevel.title }}</a
        >
      </router-link>
    </li>
  </ul>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import { RouterLink } from "vue-router";

import store from "../../store";

import findClosestDay from "../../store/getters/resolve/find-closest-day";
import findSeasonContentForSchoolLevel from "../../store/getters/resolve/find-season-content-for-school-level";

export default {
  name: "SchoolLevelMenu",
  components: {
    RouterLink,
  },
  computed: {
    ...mapState(["container"]),
    ...mapGetters([
      "activeVolume",
      "activeSchoolLevel",
      "activeSeason",
      "routedDay",
    ]),
    routes() {
      return Object.fromEntries(
        this.container?.schoolLevels.map((schoolLevel) => [
          schoolLevel.slug,
          this.route(schoolLevel),
        ]),
      );
    },
  },
  methods: {
    route(schoolLevel) {
      // For routed schoolLevel, simply return the current route.
      if (schoolLevel.slug === this.$route.params.schoolLevelSlug) {
        return this.$route;
      }

      // For the other school level, it depends on the current route:
      // If the current route is a calendar route, then we need to
      // find the other school level's matching day by date (current, future or recent).
      // Otherwise - if the current route is not a calendar route,
      // then we can simply use the same route, replacing the
      // schoolLevelSlug parameter.
      if (
        ["CalendarSheet", "CalendarSheetVideoPlayer"].includes(
          this.$route.name,
        ) &&
        this.routedDay
      ) {
        // Find the seasonContentForSchoolLevel of the other (route target) schoolLevel.
        const seasonContentForSchoolLevel = findSeasonContentForSchoolLevel(
          this.activeSeason,
          schoolLevel,
        );

        // In there, try to find the day matching the same date
        // or a near future or recent past date.
        const date = new Date(this.routedDay.date);
        const closestDay = findClosestDay(
          date,
          seasonContentForSchoolLevel,
          store,
        );

        // If we have found a (near) matching day, then make the route lead there.

        if (closestDay) {
          return {
            name: this.$route.name,
            params: {
              ...this.$route.params,
              schoolLevelSlug: schoolLevel.slug,
              daySlug: closestDay.slug,
            },
          };
        }

        // We have not found a day at or around the given date.
        // At looks like the other school level might not have any days in the active season!
        // We will need to fall through to only replacing the school level slug.
        // The CalendarSheet component will find its way, using `ensureValidDay()`
        // and `autoDay()`.
      }

      // The current route is not a calendar route. We can simply use
      // the same route, replacing the schoolLevelSlug parameter.
      return {
        name: this.$route.name,
        params: {
          ...this.$route.params,
          schoolLevelSlug: schoolLevel.slug,
        },
      };
    },
    getButtonClass(title, isActive) {
      switch (title) {
        case "Onderbouw":
          return isActive
            ? "bg-green text-white"
            : "bg-green-200 text-green hover:bg-green-500";
        case "Midden/bovenbouw":
          return isActive
            ? "bg-purple text-white"
            : "bg-purple-200 text-purple hover:bg-purple-500";
        default:
          return isActive
            ? "bg-orange text-white"
            : "bg-orange-600 text-white hover:bg-orange";
      }
    },
  },
};
</script>
